"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTierCopy = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../requests/graphql");
const error_handler_1 = __importDefault(require("../../../services/error_handler"));
const index_1 = __importDefault(require("../../icon/index"));
const Tooltip_1 = __importDefault(require("../../../client/reusable_components/Tooltip"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const badge_css_1 = __importDefault(require("./badge.css"));
const c = {
    checkmark: ({ tier, size }) => [
        util_css_1.default.circle,
        layout_css_1.default.flex,
        badge_css_1.default.checkmark,
        tier === 'HACKSTER' ? badge_css_1.default.hackster : '',
        tier === 'PARTNER' ? badge_css_1.default.partner : '',
        tier === 'PRO' ? badge_css_1.default.pro : '',
        tier === 'VERIFIED' ? badge_css_1.default.verified : '',
        size === 'small' ? badge_css_1.default.small : '',
        size === 'medium' ? badge_css_1.default.medium : '',
    ].join(' '),
};
const sizeMap = {
    small: 8,
    medium: 10,
    large: 12,
};
const getTierCopy = (tier) => {
    switch (tier) {
        case 'HACKSTER':
            return 'Hackster Admin';
        case 'PARTNER':
            return 'Pro Partner';
        case 'PRO':
            return 'Pro Contributor';
        case 'VERIFIED':
            return 'Verified Member';
        default:
            return 'Basic Member';
    }
};
exports.getTierCopy = getTierCopy;
const Badge = ({ user, size, className }) => {
    // graphql returns enum, grabbed from user object return lowercase, format to always be up cased.
    const formattedTier = user?.tier?.toUpperCase();
    const [tier, setTier] = (0, react_1.useState)(formattedTier);
    const isHackster = tier === 'HACKSTER';
    const tip = (0, exports.getTierCopy)(tier);
    // In some instances, cachedProjects for instance, will not _always_ return tier. As a fallback,
    // If we don't have tier, fetch it from the user.
    (0, react_1.useEffect)(() => {
        if (tier)
            return;
        if (!user?.id) {
            setTier('BASIC');
            return;
        }
        (0, graphql_1.graphQuery)({ t: 'get_user' }, { id: user.id })
            .then(({ user }) => {
            // if user is not returned, fallback to basic
            setTier(user?.tier.toUpperCase() || 'BASIC');
        })
            .catch((err) => {
            (0, error_handler_1.default)('User Badge Error:', err);
            setTier('BASIC');
        });
    }, [tier, user]);
    if (tier === 'BASIC' || tier === 'PENDING' || !tier)
        return null;
    return (
    // @ts-expect-error TODO: Convert Tooltip to TS
    react_1.default.createElement(Tooltip_1.default, { align: "center", collisionPadding: 15, content: tip, onClick: () => window.location.assign('/pro'), sideOffset: 5, variant: "secondary" },
        react_1.default.createElement("div", { className: `${c.checkmark({ tier, size })} ${className}` },
            react_1.default.createElement(index_1.default, { name: isHackster ? 'hackster' : 'checkmark-bold', size: sizeMap[size] || 12 }))));
};
exports.default = Badge;
